import type { FaireProductEntity } from "../../entity_types/product";

export const p_5frbasjfnh: FaireProductEntity = {
  token: "p_5frbasjfnh",
  type: "product",
  name: "Seasonal Single Serve Cocktail Package",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/27992ab0a953c8adadf0e6e8970ad97469b0860518390142388d5f4bbbc985d4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/664a173fd6c1d58573f691f8dc7124e80a54d078d033d155e83c3b7d8a24a1ff.png",
    "https://cdn.faire.com/fastly/341afa0207ce8494157d1b65478dee310c22411cb10918257333462b791ca41d.jpeg",
    "https://cdn.faire.com/fastly/26990ba65d661864d2ae07bb6ff679ebcb1e881e323ccf0f047f54efd1c1c32d.jpeg",
    "https://cdn.faire.com/fastly/cf6cd99500ed039f919e5ac1a1938b6b19052f361d12ea9fc55bdc9ba99b62b4.jpeg",
    "https://cdn.faire.com/fastly/5ec412b2afcf3a6f18d208aaa13d353bac91ed6461c56b23c1a89011976db4ea.jpeg",
  ],
  priceDollars: 1.48,
  description:
    "Warm up or chill out with our curated mix of seasonal cocktails. Whether you're gathering with friends, hosting a quiet evening in, or simply embracing the festive mood, these cocktails bring a touch of seasonal magic — no matter what you’re celebrating.\n\nOur seasonal single serve cocktails make the perfect stocking stuffers - we won't tell if you keep some for yourself!\n\nThis package includes 96 total cocktails - 24 Hot Toddy, 24 Irish Coffee, 24 Pumpkin Spice Chai Martini, and 24 S'mores Hot Cocoa. $1.40 each, recommended MSRP $2.95\n\nMake sure to add any seasonal display boxes you want to your order as well - they are not sent automatically with your order! https://www.faire.com/product/p_nhvkrcd5eg",
  tags: [],
  msrpDollars: 2.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:02.151Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
